<div class="wrapper">
  <div class="title">
  {{title()}}
</div>
  <div class="sub-title">
  {{subtitle()}}
</div>
</div>

